<template>
  <component 
    :is="componentType" 
    v-if="shouldShow"
    :class="wrapperClasses"
    v-tooltip.bottom="tooltipText"
  >
    <icon 
      data="@icon/vestr-icon.svg" 
      :class="['vestr p-relative', customClass ,{ 'vertical-align': !useTag}]"
    />
  </component>
</template>

<script>
import { computed } from 'vue'
import { useAccountStore } from "@/stores/account"
import { PaymentFlowType } from "@/components/workflow/PaymentFlow/Types"
import { WorkflowType } from "@/components/workflow/Types"
import Tooltip from "primevue/tooltip"
import Tag from "primevue/tag"

export default {
  name: "VestrIndicator",
  components: {
    Tag
  },
  directives: {
    tooltip: Tooltip,
  },
  props: {
    hasVestr: Boolean,
    workflowDefinitionId: String,
    paymentFlowTypeId: Number,
    customClass: {
      type: String,
      default: ""
    },
    useTag: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const accountStore = useAccountStore()

    const componentType = computed(() => props.useTag ? 'Tag' : 'span')
    
    const wrapperClasses = computed(() => ({
      'p-relative z-50': true,
      'p-tag-inverted': props.useTag,
      'p-text-uppercase': props.useTag,
      [props.wrapperClass]: !!props.wrapperClass
    }))

    const tooltipText = 'Data Provider - Vestr'

    return {
      accountStore,
      componentType,
      wrapperClasses,
      tooltipText
    }
  },
  computed: {
    user() {
      return this.accountStore.user
    },
    isAuthorizedUser() {
      return this.user?.isUserGentwo || this.user?.isISP
    },
    isVestrWorkflow() {
      if (!this.workflowDefinitionId) return true
      
      return [
        WorkflowType.PaymentInstruction,
        WorkflowType.QuarterlyFees,    
        WorkflowType.G2QuarterlyFees,
        WorkflowType.SecondaryIncreaseDecrease,
        WorkflowType.ProductTermination,
        WorkflowType.Coupon,
        WorkflowType.PartialRedemptionEvent
      ].includes(this.workflowDefinitionId)
    },
    isAllowedPaymentFlow() {
      if (!this.paymentFlowTypeId) return true
      
      return [
        PaymentFlowType.SALES_FEE,
        PaymentFlowType.QUARTERLY_FEES
      ].includes(this.paymentFlowTypeId)
    },
    shouldShow() {
      return this.isAuthorizedUser && 
             this.hasVestr && 
             this.isVestrWorkflow && 
             this.isAllowedPaymentFlow
    }
  }
}
</script>

<style scoped lang="scss">
.vertical-align {
  vertical-align: text-bottom;
}
</style>
